import { UtensilsCrossed } from "lucide-react";

/**
 * Typographic placeholder logo for ERP Alimentos.
 * Replace with <img src="images/logo-erp-alimentos.png" /> when the user provides the file.
 */
export const Logo = ({ variant = "dark", compact = false }) => {
  const isLight = variant === "light";
  const text = isLight ? "text-white" : "text-zinc-950";
  const accent = isLight ? "text-orange-400" : "text-orange-500";
  const ring = isLight
    ? "bg-white/10 ring-1 ring-white/20"
    : "bg-emerald-900 ring-1 ring-emerald-900/10";

  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="erp-logo">
      <div
        className={`relative grid place-items-center w-9 h-9 rounded-lg ${ring}`}
      >
        <UtensilsCrossed className="w-4.5 h-4.5 text-white" size={18} />
        <span
          className={`absolute -bottom-0.5 -right-0.5 w-2 h-2 rounded-full bg-orange-500 ring-2 ${
            isLight ? "ring-zinc-950" : "ring-white"
          }`}
        />
      </div>
      {!compact && (
        <div className="leading-none">
          <div className={`font-display font-black text-[15px] tracking-tight ${text}`}>
            ERP <span className={accent}>Alimentos</span>
          </div>
          <div
            className={`mt-1 text-[9px] uppercase tracking-[0.22em] font-semibold ${
              isLight ? "text-white/60" : "text-zinc-500"
            }`}
          >
            Restaurant OS
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
